import type { FlatNode } from "screens/call/callscript-graph-to-nested";

import styles from "./index.module.css";

type CallComplianceMissedProps = {
  toggleIsOpen: (itemId: string) => void;
  isOpen: boolean;
  missedCompliance: FlatNode[];
  disabled?: boolean;
};

export const CallComplianceMissed = ({
  toggleIsOpen,
  isOpen,
  missedCompliance,
  disabled = false,
}: CallComplianceMissedProps) => {
  return (
    <div className={styles.accordion}>
      <div className={styles.accItem} data-open={isOpen ? "true" : "false"}>
        <button
          type="button"
          className={styles.accSummary}
          aria-expanded={isOpen}
          aria-controls={`acc-panel-compliance`}
          data-open={isOpen ? "true" : "false"}
          onClick={() => toggleIsOpen("compliance")}
          aria-disabled={disabled}
          disabled={disabled}
        >
          {`Compliance Phrases Missed (${missedCompliance.length})`}
          <span
            className={styles.accChevron}
            data-open={isOpen ? "true" : "false"}
            aria-hidden="true"
            aria-disabled={disabled}
          />
        </button>

        <div
          id={`acc-panel-compliance`}
          role="region"
          className={styles.accContent}
          hidden={!isOpen}
        >
          <ul>
            {missedCompliance.map((comp) => {
              return <li key={comp.id}>{comp.displayName}</li>;
            })}
          </ul>
        </div>
      </div>
    </div>
  );
};
